import { gql } from '@apollo/client';

export const deleteVehicleIdCard = gql`
  mutation deleteVehicleIdCard($input: DeleteVehicleIdCardInput!) {
    deleteVehicleIdCard(input: $input) {
      success
    }
  }
`;
